import styled from 'styled-components';

export const ThematicAreaBadge = styled.li`
  padding-bottom: 0.1rem;
  list-style: circle;
  text-decoration: underline;
`;
